export const filterTypes = [
  {
    name: "Monitoramento",
    description: "Filtro do Monitoramento",
    path: () => import("../components/Monitoramento/MainMonitoramento.vue")
  },
  {
    name: "BI",
    description: "Filtro do BI",
    path: () => import("../components/BI/MainBI.vue")
  },
  {
    name: "Telemetria",
    description: "Filtro da Telemetria",
    path: () => import("../components/Telemetria/MainTelemetria.vue")
  }
];
